var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"not-copy"},[_c('foreignObject',{attrs:{"x":_vm.x,"y":_vm.y,"height":"100","width":"100"}},[_c('img',{staticClass:"img-icon",style:(_vm.transform),attrs:{"src":require("@/assets/virtualoffice/interior/monitor1.png"),"xmlns":"http://www.w3.org/1999/xhtml"}})]),_vm._v(" "),_c('rect',{attrs:{"x":_vm.x,"y":_vm.y,"height":"100","width":"100","fill":"transparent"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d61ef8a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DashBoard/VirtualOffice/Interior/Monitor.vue
// module id = null
// module chunks = 